/* eslint-disable react/forbid-component-props */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/forbid-elements */
import { SecureStore } from '../../utils/secure-storage'
import { YStack, isWeb } from '@bounty/creators-design-system'
import Script from 'next/script'
import { useRouter } from 'solito/router'
import { SAYMORE_SURVEY_ID, SAYMORE_WIDGET_URL } from '../../config/env'
import { useAuthState } from '../../hooks'
import { useTrackPage } from '../../hooks/useTrackPage'

const useUserIdSafe = (params: { [x: string]: string }) => {
  const { user } = useAuthState()

  if (user?.userId) return user.userId
  if (params.userId) return params.userId

  return 'anonymous'
}

const FeedbackComponent = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const userId = useUserIdSafe(params)
  const surveyId = SAYMORE_SURVEY_ID
  const router = useRouter()

  useTrackPage('Feedback', params)

  const onSubmit = () => {
    router.push('/')
  }

  const onLoad = async () => {
    // @ts-expect-error ignore
    window.SayMore.show({
      surveyId,
      userId,
      showWidget: true,
      openRecorder: true,
      showCloseButton: false,
      position: 'static',
      onSubmit,
    })

    await SecureStore.setItem('feedbackReceived', 'true')
  }

  return (
    <YStack
      flex={1}
      alignItems="center"
      justifyContent="center"
      position="relative"
      height="100dvh"
      overflow="hidden"
    >
      <div data-widget-host="saymore-direct-widget"></div>
      <Script async onLoad={onLoad} src={SAYMORE_WIDGET_URL}></Script>
    </YStack>
  )
}

// Canvas breaks SSR so we do this to make it client side only
export const Feedback = () => {
  const router = useRouter()

  // Does not work on native
  if (!isWeb) {
    router.push('/')
    return null
  }

  return <FeedbackComponent />
}
